// extracted by mini-css-extract-plugin
export default {"home-wrapper":"Home_home-wrapper__ta9E8"};